import { isZoomInEvent, isZoomOutEvent, isZoomResetEvent } from 'utils/hotkeys';

import useMount from './common/useMount';

const useZoom = () => {
  useMount(() => {
    const preventZoomWithHotkey = (event: KeyboardEvent) => {
      if (isZoomInEvent(event) || isZoomOutEvent(event) || isZoomResetEvent(event)) {
        event.preventDefault();
      }
    };

    const preventZoomWithTouchpad = (event: WheelEvent) => {
      (event.ctrlKey || event.metaKey) && event.preventDefault();
    };

    const gestureEvent = (event: any) => {
      event.preventDefault();
    };

    document.addEventListener('keydown', preventZoomWithHotkey);
    document.addEventListener('gestureend', gestureEvent);
    document.addEventListener('gesturestart', gestureEvent);
    document.addEventListener('gesturechange', gestureEvent);
    document.addEventListener('wheel', preventZoomWithTouchpad, { passive: false });

    // TODO: Cascade creates a new viewport meta tag and overwrites our.
    setTimeout(() => {
      const viewportMetaTags = document.querySelectorAll('meta[name="viewport"]');

      if (viewportMetaTags.length) {
        viewportMetaTags.forEach(metaTag => {
          metaTag.setAttribute(
            'content',
            'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, interactive-widget=resizes-content, viewport-fit=cover',
          );
        });
      }
    }, 1000);

    return () => {
      document.removeEventListener('keydown', preventZoomWithHotkey);
      document.removeEventListener('wheel', preventZoomWithTouchpad);
      document.removeEventListener('gestureend', gestureEvent);
      document.removeEventListener('gesturestart', gestureEvent);
      document.removeEventListener('gesturechange', gestureEvent);
    };
  });
};

export default useZoom;
